module.exports = __webpack_public_path__ + "img/HZ.dfb1c366.png";